export default {
  LANGUAGES: ['pl'],
  DEFAULT_LANG: 'pl',
};
